module.exports = __webpack_public_path__ + "img/13csm_Ersa-VERSAFLOW-ONE-01-1920x540_23d143e0d1.4131b60e.jpg";